function initUploadPrivacyLink(root) {
  const mount = root.querySelector('.wl-form-app [data-forms-id="forms-root-1170104"]');
  if (!mount) return;
  const privacyUrl = 'https://wiens3d.de/pages/datenschutzerklarung';
  const observed = new WeakSet();

  // Shopify Forms renders plain checkbox labels inside its own shadow root.
  // Keep the original input and value; only enrich the displayed consent text.
  function enhance(shadow) {
    const checkbox = shadow.querySelector('input[type="checkbox"][name="custom#datenschutz"]');
    const label = checkbox?.closest('label');
    const text = label?.querySelector('span');
    if (text && !text.querySelector('[data-wl-privacy-link]')) {
      const word = 'Datenschutzerklärung';
      const node = [...text.childNodes].find(child => child.nodeType === Node.TEXT_NODE && child.textContent.includes(word));
      if (node) {
        const offset = node.textContent.indexOf(word);
        const link = document.createElement('a');
        link.textContent = word;
        link.href = privacyUrl;
        link.dataset.wlPrivacyLink = 'true';
        link.title = 'Datenschutzerklärung (öffnet in einem neuen Tab)';
        // Opening the policy must not change the customer's checkbox choice.
        link.addEventListener('click', event => event.stopPropagation());
        node.replaceWith(document.createTextNode(node.textContent.slice(0, offset)), link,
          document.createTextNode(node.textContent.slice(offset + word.length)));
      }
    }
    for (const link of shadow.querySelectorAll(`a[href="${privacyUrl}"]`)) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.style.textDecoration = 'underline';
      link.style.textUnderlineOffset = '0.15em';
    }
  }
  function bind() {
    const shadow = mount.querySelector('shopify-forms-embed')?.shadowRoot;
    if (!shadow) return false;
    if (!observed.has(shadow)) {
      observed.add(shadow);
      new MutationObserver(() => enhance(shadow)).observe(shadow, {childList:true, subtree:true, characterData:true});
      enhance(shadow);
    }
    return true;
  }
  new MutationObserver(bind).observe(mount, {childList:true, subtree:true});
  if (!bind()) {
    let attempts = 0;
    const timer = setInterval(() => {
      if (bind() || !root.isConnected || ++attempts >= 120) clearInterval(timer);
    }, 250);
  }
}

export function initLanding(root = document.getElementById('wiens-lasergravur')) {
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  initUploadPrivacyLink(root);
  const menu = root.querySelector('.wl-mobile-menu');
  const menuButton = root.querySelector('.wl-menu-toggle');
  const lightbox = root.querySelector('.wl-lightbox');
  const images = [...root.querySelectorAll('[data-gallery-image]')];
  let imageIndex = 0;
  let oldOverflow = '';
  let oldPadding = '';
  let lastTrigger;
  function lockScroll() {
    oldOverflow = document.body.style.overflow;
    oldPadding = document.body.style.paddingRight;
    document.body.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`;
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    document.body.style.overflow = oldOverflow;
    document.body.style.paddingRight = oldPadding;
  }
  // The Shopify layout owns navigation; the standalone menu is optional.
  if (menu && menuButton) {
    function closeMenu() { if (menu.open) menu.close(); }
    menuButton.addEventListener('click', () => { lockScroll(); menu.showModal(); menuButton.setAttribute('aria-expanded', 'true'); });
    menu.querySelector('[data-menu-close]').addEventListener('click', closeMenu);
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
    menu.addEventListener('close', () => { unlockScroll(); menuButton.setAttribute('aria-expanded', 'false'); menuButton.focus({preventScroll:true}); });
    window.matchMedia('(min-width: 951px)').addEventListener('change', event => { if(event.matches) closeMenu(); });
  }
  function showImage(index) {
    imageIndex = (index + images.length) % images.length;
    const image = images[imageIndex].querySelector('img');
    const large = lightbox.querySelector('.wl-lightbox-image');
    large.src = images[imageIndex].dataset.fullSrc || image.currentSrc || image.src; large.alt = image.alt;
    lightbox.querySelector('figcaption').textContent = image.alt;
    lightbox.querySelector('.wl-lightbox-count').textContent = `${imageIndex + 1} / ${images.length}`;
  }
  images.forEach((button, index) => button.addEventListener('click', () => { lastTrigger = button; showImage(index); lockScroll(); lightbox.showModal(); }));
  lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
  lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', () => showImage(imageIndex - 1));
  lightbox.querySelector('[data-lightbox-next]').addEventListener('click', () => showImage(imageIndex + 1));
  lightbox.addEventListener('keydown', event => {
    if(event.key === 'ArrowRight') {event.preventDefault(); showImage(imageIndex + 1);}
    if(event.key === 'ArrowLeft') {event.preventDefault(); showImage(imageIndex - 1);}
  });
  lightbox.addEventListener('click', event => {
    const box = lightbox.getBoundingClientRect();
    if(event.target === lightbox && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) lightbox.close();
  });
  lightbox.addEventListener('close', () => { unlockScroll(); lastTrigger?.focus({preventScroll:true}); });
  const form = root.querySelector('#wl-contact-form');
  const requiredTextFields = form?.querySelectorAll('#wl-name, #wl-message') || [];
  for (const field of requiredTextFields) {
    const validateText = () => field.setCustomValidity(field.value.trim() ? '' : (
      field.id === 'wl-name'
        ? 'Bitte geben Sie Ihren Namen ein.'
        : 'Bitte beschreiben Sie Ihr Projekt.'
    ));
    validateText();
    field.addEventListener('input', validateText);
    field.addEventListener('change', validateText);
  }
  const result = root.querySelector('.wl-form-status:not([hidden])');
  if(result) result.focus();
}
initLanding();
document.addEventListener('shopify:section:load', () => initLanding());

